import axios from 'axios';
import { userService } from '@/services/user';

const REFRESH_RETRY_LIMIT = 5;
const RETRY_REQUEST_TIMEOUT = 2000;

const formatAuthBearerHeader = (accessToken: string) => `Bearer ${accessToken}`;

const setTimeoutPromise = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

axios.interceptors.response.use(undefined, async (error) => {
  // Do not retry cases from login
  if (error.config && error.config.isFromLogin) {
    return Promise.reject(error);
  }

  if (error.config && error.response && error.response.status === 401) {
    try {
      const tokenResponse = await userService.refreshUserSession();
      const { token } = tokenResponse;

      if (token) {
        const { config } = error;
        const { attempts } = config;
        config.headers.Authorization = formatAuthBearerHeader(token);
        config.attempts = attempts ? attempts + 1 : 1;

        if (config.attempts >= REFRESH_RETRY_LIMIT) {
          // Log user out if too many failed retries
          // eslint-disable-next-line no-console
          console.warn('Too many failed attempts, logging user out.');
          return await userService
            .logout()
            .then((logoutError) => Promise.reject(logoutError));
        }

        return await setTimeoutPromise(RETRY_REQUEST_TIMEOUT).then(() =>
          axios.request(config),
        );
      }

      return await Promise.reject(error);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Refresh user session attempt failed', err);
    }
  }

  return Promise.reject(error);
});
